'use client'

/* eslint-disable no-restricted-syntax */
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { useEffect, useState } from 'react'
import { SCROLL_EVENT, SCROLL_THRESHOLDS } from './scrollConstants'

interface ScrollProps {
  segmentEventCommonProperties: Object
}

const Scroll = ({ segmentEventCommonProperties }: ScrollProps) => {
  const [triggeredScrollPositions, setTriggeredScrollPositions] = useState<Record<number, boolean>>({})

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrolledPercentage = Math.floor((scrollTop / (documentHeight - windowHeight)) * 100)

      for (const threshold of SCROLL_THRESHOLDS) {
        if (scrolledPercentage >= threshold && !triggeredScrollPositions[threshold]) {
          setTriggeredScrollPositions(prev => ({ ...prev, [threshold]: true }))
          void pageEvent(SCROLL_EVENT, {
            ...segmentEventCommonProperties,
            vertical_scroll: `${threshold}%`,
          })
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [triggeredScrollPositions])

  return null
}

export default Scroll
